import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGS = ['sk', 'cs', 'de', 'en', 'ru'];

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
}) => {
  const { i18n } = useTranslation();
  const currentLang = (i18n.language || 'sk').split('-')[0];

  const siteName = 'Sunify';
  // Origin from the running browser — works correctly for both prod
  // (sunify.sk) and preview deployments. SSR-safe fallback to prod.
  const siteUrl = (typeof window !== 'undefined' && window.location?.origin) || 'https://sunify.sk';
  const defaultImage = `${siteUrl}/logo.png`;

  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const ogImage = image || defaultImage;

  return (
    <Helmet>
      <html lang={currentLang} />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph (Facebook, WhatsApp, Telegram, LinkedIn) */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={currentLang} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {/* SEO basics */}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={fullUrl} />

      {/* Hreflang alternates — single-URL i18n: same URL serves every language,
          we tell Google all 5 are equivalent and offer an x-default. */}
      {SUPPORTED_LANGS.map((lang) => (
        <link key={lang} rel="alternate" hrefLang={lang} href={fullUrl} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={fullUrl} />
    </Helmet>
  );
};

export default SEO;
